const s = (t, r) => {
  const o = t.__vccOpts || t;
  for (const [c, e] of r)
    o[c] = e;
  return o;
};
export {
  s as _
};
